import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "./CoursesPlaces.css"; // For styling the component
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal"; // Importing react-modal
import { fetchCourses, deleteCourse, deleteDate } from "../../redux/actions/coursePlacesActions";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MultiSelect from "../MultiSelect/MultiSelect";
import { useNotification } from "../Notification/NotificationContext";
import Swal from "sweetalert2";
Modal.setAppElement("#root");
const CoursesPlaces = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const courses = useSelector((state) => state.coursesPlaces.coursesPlaces);
  const username = useSelector((state) => state.auth.user?.username);
  const [showDevSettings, setShowDevSettings] = useState(false);
  const [isDevModeUnlocked, setIsDevModeUnlocked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const rowsRef = useRef([]);
  const [isLoading, setIsLoading] = useState(true);

  // Add states for payment link regeneration
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [regenerationReport, setRegenerationReport] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [regenerationProgress, setRegenerationProgress] = useState({
    currentBatch: 0,
    totalBatches: 0,
    processedDates: 0,
    totalDates: 0,
    percentage: 0
  });

  // Function to handle developer password prompt
  const handleDevModeToggle = async () => {
    if (isDevModeUnlocked) {
      // If already unlocked, just toggle the settings visibility
      setShowDevSettings(!showDevSettings);
      return;
    }

    // Prompt for password
    const { value: password } = await Swal.fire({
      title: 'Developer Access Required',
      html: `
        <div style="text-align: left; margin: 20px 0;">
          <p style="margin-bottom: 15px; color: #666;">
            Enter the developer password to access advanced settings:
          </p>
        </div>
      `,
      input: 'password',
      inputPlaceholder: 'Enter developer password',
      inputAttributes: {
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      showCancelButton: true,
      confirmButtonColor: '#333',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Unlock Developer Mode',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'Password is required!'
        }
      }
    });

    if (password) {
      // Check password against environment variable
      const expectedPassword = process.env.REACT_APP_DEVELOPER_PASSWORD || 'sassoon2024dev';
      
      if (password === expectedPassword) {
        setIsDevModeUnlocked(true);
        setShowDevSettings(true);
        
        Swal.fire({
          title: 'Developer Mode Unlocked!',
          text: 'You now have access to advanced developer settings.',
          icon: 'success',
          confirmButtonColor: '#333',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        Swal.fire({
          title: 'Access Denied',
          text: 'Invalid developer password. Please try again.',
          icon: 'error',
          confirmButtonColor: '#333'
        });
      }
    }
  };

  // Event listener for Alt+D keyboard shortcut
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check for Alt+Shift+D (keyCode 68 is 'D')
      if (event.altKey && event.shiftKey && event.keyCode === 68) {
        handleDevModeToggle();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    
    // Cleanup
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showDevSettings, isDevModeUnlocked]);

  const region = username === "ukadmin" ? "United Kingdom" : "United States";
  const [regionfilter, setRegionFilter] = useState(
    username === "ukadmin" ? "uk" : "us"
  );

  const coursesData = courses || [];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);

  console.log('coursesData : ', coursesData);

  const [filters, setFilters] = useState({
    category: [],
    title: [],
    location: [],
    date: [],
    price: [],
    visibility: [],
    practiceOption: [],
    duration: [],
  });

  const initialFormData = {
    date: "",
    availablePlaces: "",
    priceWithVat: 0,
    priceExVat: 0,
    depositAmount: "",
    visibility: "Shown",
    practiceOption: "Notspecified",
    currency: "",
    visible_price: "price_with_vat",
    actual_price: "price_with_vat",
    payment: {
      url: "",
      type: "full",
      percentage: 0
    }
  };

  const initialSelectedCourseFormData = {
    courseid: "",
    region: "",
    category: [],
    title: "",
    duration: "",
    duration_unit: "",
    location: "",
    visibility: "show",
    currency: "",
    visible_price: "",
  };

  const uniqueSelectionCategories = [
    "Barber",
    "Beginners",
    "Long Term",
    "Month of Mondays",
    "Short Term Colour",
    "Short Term Cut",
    "Short Term Cut & Colour",
    "Shows & Events",
    "Specialist",
  ];

  const categorySelectionOptions = uniqueSelectionCategories.map(
    (category, index) => ({
      value: category,
      label: category,
      id: `category-selection-${index}-${category}`
    })
  );

  const formatDate = (dateString) => {
    // If already in formatted form, return as is
    if (dateString && dateString.includes(' ')) return dateString;
    
    // Parse the date without timezone conversion
    const parts = dateString.split('-');
    if (parts.length !== 3) return dateString; // Return as is if not in YYYY-MM-DD format
    
    const year = parts[0];
    const month = parseInt(parts[1]) - 1; // JS months are 0-indexed
    const day = parseInt(parts[2]);
    
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                   'July', 'August', 'September', 'October', 'November', 'December'];
                   
    // Format as "DD Month YYYY" without timezone conversion
    return `${day.toString().padStart(2, '0')} ${months[month]} ${year}`;
  };

  // Function to unformat a date string
  const unformatDate = (formattedDate) => {
    if (!formattedDate || !formattedDate.includes(' ')) return formattedDate;
    
    const months = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const parts = formattedDate.split(' ');
    if (parts.length !== 3) return formattedDate;
    
    const day = parts[0];
    const month = months[parts[1]];
    const year = parts[2];
    
    return `${year}-${month}-${day.padStart(2, '0')}`;
  };
  // Assuming you have a state hook for form data
  const [formData, setFormData] = useState(initialFormData);

  // State hook for selected course
  const [selectedCourseFormData, setSelectedCourseFormData] = useState(
    initialSelectedCourseFormData
  );
  const [editCourse, setEditCourse] = useState(null);

  const handleMultiSelectChange = (selected, fieldName) => {
    // Store this array directly in your form state
    setSelectedCourseFormData((prevState) => ({
      ...prevState,
      [fieldName]: selected || selected.map((item) => item.value || item),
    }));
  };

  // Set formData to initialFormData if selectedCourse is not available or if it's empty
  useEffect(() => {
    if (selectedCourse) {
      setFormData({
        id: selectedCourse._id || "",
        date: selectedCourse.date || "",
        availablePlaces: selectedCourse.available_places || "",
        priceWithVat: selectedCourse.price_with_vat || 0,
        priceExVat: selectedCourse.price_without_vat || 0,
        depositAmount: selectedCourse.deposit_amount || "",
        visibility: selectedCourse.visibility || "Shown",
        practiceOption: selectedCourse.practice_option || "Notspecified",
        currency: selectedCourse.currency || "",
        visible_price: selectedCourse.visible_price || "price_with_vat",
        actual_price: selectedCourse.actual_price || "price_with_vat",
        payment: {
          url: selectedCourse.payment?.url || "",
          type: selectedCourse.payment?.type || "full",
          percentage: selectedCourse.payment?.percentage || 0,
          payment_link_id: selectedCourse.payment?.payment_link_id || "",
        }
      });
    }
  }, [selectedCourse]);

  

  useEffect(() => {
    const categoryArr = editCourse?.category.map((item) => ({
      value: item,
      label: item,
    }));

    if (editCourse && typeof editCourse === "object") {
      setSelectedCourseFormData({
        id: editCourse._id || "",
        courseid: editCourse.courseid || "",
        region: editCourse.region || "",
        category: categoryArr || [],
        title: editCourse.title || "",
        duration: editCourse.duration || "",
        duration_unit: editCourse.duration_unit || "",
        location: editCourse.location || "",
        visibility: editCourse.visibility || "show",
        currency: editCourse.currency || (editCourse.region === "uk" ? "GBP" : "USD"),
        visible_price: editCourse.visible_price || "",
      });
      //console.log("EditCourseFormData : ", selectedCourseFormData);
    }
  }, [editCourse]);

  // useEffect(() => {
  // 	console.log("Updated selectedCourseFormData:", selectedCourseFormData);
  // }, [selectedCourseFormData]);

  const openModal = (type, course = null, courseFormData = null) => {
    if (type === "newCourse") {
      navigate("/new-user"); // Redirect to /new-user
    } else {
      setModalType(type);
      setSelectedCourse(course);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalType("");
    setSelectedCourse(null);
  };

  const handleFilterChange = (selected, name) => {
    console.log(`Filter changed: ${name}`, selected);
    setFilters(prevFilters => {
      const newFilters = {
        ...prevFilters,
        [name]: selected,
      };
      console.log("New filters:", newFilters);
      return newFilters;
    });
  };

  const isEntry = Object.values(filters).some(
    (arr) => Array.isArray(arr) && arr.length > 0
  );

  // Fetch courses data on component mount
  useEffect(() => {
    setIsLoading(true);
    dispatch(fetchCourses()).then(() => {
      setIsLoading(false);
    });
  }, [dispatch]);

  const uniqueCategories = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .map((course) => course.category)
    ),
  ];

  const categoryOptions = uniqueCategories.map((category, index) => ({
    label: category,
    value: category,
    id: `category-${index}-${category}`
  }));
  const uniqueTitles = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .map((course) => course.title)
    ),
  ];

  const titleOptions = uniqueTitles.map((title, index) => ({
    label: title,
    value: title,
    id: `title-${index}-${title}`
  }));
  const uniqueDurations = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .map((course) => course.duration)
    ),
  ];
  const durationOptions = uniqueDurations.map((duration, index) => ({
    label: duration,
    value: duration,
    id: `duration-${index}-${duration}`
  }));
  const uniqueLocations = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .map((course) => course.location)
    ),
  ];

  // Map unique locations to objects for MultiSelect options
  const locationOptions = uniqueLocations.map((location, index) => ({
    label: location,
    value: location,
    id: `location-${index}-${location}`
  }));
  const uniqueDates = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .flatMap((course) => course.dates.map((dateInfo) => dateInfo.date))
    ),
  ].sort((a, b) => new Date(a) - new Date(b));

  // Removing first empty string
  if (uniqueDates.length > 0 && uniqueDates[0] === "") {
    uniqueDates.shift();
  }

  const dateOptions = uniqueDates.map((date, index) => ({
    label: date,
    value: date,
    id: `date-${index}-${date}`
  }));

  const uniquePrices = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .flatMap((course) =>
          course.dates.map((dateInfo) => dateInfo.price_with_vat)
        )
    ),
  ];

  const priceOptions = uniquePrices.map((price, index) => ({
    label: price,
    value: price,
    id: `price-${index}-${price}`
  }));

  const uniqueVisibilities = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .flatMap((course) =>
          course.dates.map((dateInfo) => dateInfo.visibility)
        )
    ),
  ];

  const visibilityOptions = uniqueVisibilities.map((visibility, index) => ({
    label: visibility,
    value: visibility,
    id: `visibility-${index}-${visibility}`
  }));

  const uniquePracticeOptions = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .flatMap((course) =>
          course.dates.map((dateInfo) => dateInfo.practice_option)
        )
    ),
  ];
  const uniqueBookings = [
    ...new Set(
      coursesData
        .filter((course) => course.region === regionfilter)
        .flatMap((course) =>
          course.dates.map((dateInfo) => dateInfo.booked_places)
        )
    ),
  ];

  const bookingsOption = uniqueBookings.map((booked_places, index) => ({
    label: booked_places,
    value: booked_places,
    id: `bookings-${index}-${booked_places}`
  }));

  const practiceOptions = uniquePracticeOptions.map((practice_option, index) => ({
    label: practice_option,
    value: practice_option,
    id: `practice-${index}-${practice_option}`
  }));

  const handleEditCourseSubmit = async (e) => {
    // Prevent default form submission
    e.preventDefault();

    const token = localStorage.getItem("sassoontoken");
    if (!token) {
      showNotification("Please login first.", "error");
      return;
    }

    // Create a copy of the form data so we don't modify the state directly
    const submissionData = {
      ...selectedCourseFormData,
      category: selectedCourseFormData.category
        .filter((category) => category != null) // Filter out null items
        .map((category) => category?.value), // Map to values
      visibility: selectedCourseFormData.visibility || "show", // Ensure visibility is explicitly included
      currency: selectedCourseFormData.currency || (selectedCourseFormData.region === "uk" ? "GBP" : "USD"),
      visible_price: selectedCourseFormData.visible_price || "",
    };

    console.log("Submitting course data:", submissionData);

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/updateCourse/${submissionData.id}`,
        submissionData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      showNotification("Course updated successfully!", "success");
      closeModal();
      dispatch(fetchCourses());
    } catch (error) {
      console.error("Error updating course:", error);
      showNotification("Error updating course. Please try again.", "error");
    }
  };

  // Add function to format price with VAT label
  const formatPriceWithLabel = (priceWithVat, priceWithoutVat, currency, visiblePrice = 'price_with_vat', depositAmount = 0, region = 'uk', course = null) => {
    // For US region, don't show VAT labels
    const showVatLabels = region === 'uk';
    
    // Check if we have valid date-level pricing
    const hasDatePricing = priceWithVat > 0 || priceWithoutVat > 0 || depositAmount > 0;
    
    // If no date-level pricing and we have course-level defaults, use those
    if (!hasDatePricing && course && course.visible_price > 0) {
      return `${course.currency || currency} ${course.visible_price}`;
    }
    
    if (visiblePrice === 'price_with_vat' && priceWithVat > 0) {
      return showVatLabels ? `${currency} ${priceWithVat} (Inc VAT)` : `${currency} ${priceWithVat}`;
    } else if (visiblePrice === 'price_without_vat' && priceWithoutVat > 0) {
      return showVatLabels ? `${currency} ${priceWithoutVat} (Exc VAT)` : `${currency} ${priceWithoutVat}`;
    } else if (visiblePrice === 'deposit_amount' && depositAmount > 0) {
      return `${currency} ${depositAmount} (Deposit)`;
    } else if (priceWithVat > 0) {
      return showVatLabels ? `${currency} ${priceWithVat} (Inc VAT)` : `${currency} ${priceWithVat}`;
    } else if (priceWithoutVat > 0) {
      return showVatLabels ? `${currency} ${priceWithoutVat} (Exc VAT)` : `${currency} ${priceWithoutVat}`;
    } else {
      return "-"; // Return dash if no price is available
    }
  };

  // Helper function to get displayable rows
  const getDisplayRows = useCallback(() => {
    console.log("Running getDisplayRows with filters:", JSON.stringify(filters));
    if (isEntry) {
      // When filters are applied
      return coursesData
        .filter((course) => {
          // Check if the course matches the region filter
          if (course.region !== regionfilter) return false;

          // Check for category, title, location, and duration filters
          const categoryMatch =
            filters.category.length === 0 ||
            filters.category.some((filter) => {
              if (Array.isArray(course.category)) {
                return course.category.includes(filter.value);
              }
              return filter.value === course.category;
            });
          
          const titleMatch =
            filters.title.length === 0 ||
            filters.title.some((filter) => filter.value === course.title);
          
          const locationMatch =
            filters.location.length === 0 ||
            filters.location.some((filter) => filter.value === course.location);
          
          const durationMatch =
            filters.duration.length === 0 ||
            filters.duration.some((filter) => filter.value === course.duration);

          // Course level filters
          if (!categoryMatch || !titleMatch || !locationMatch || !durationMatch) {
            return false;
          }

          // Check date-level filters
          if (filters.date.length > 0 || filters.price.length > 0 || 
              filters.visibility.length > 0 || filters.practiceOption.length > 0) {
            // Filter dates array for any date that matches ALL selected date-level filters
            const matchingDates = course.dates.filter(dateInfo => {
              const dateMatch =
                filters.date.length === 0 ||
                filters.date.some((filter) => filter.value === dateInfo.date);
              
              const priceMatch =
                filters.price.length === 0 ||
                filters.price.some((filter) => {
                  return parseFloat(filter.value) === parseFloat(dateInfo.price_with_vat);
                });
              
              const visibilityMatch =
                filters.visibility.length === 0 ||
                filters.visibility.some((filter) => filter.value === dateInfo.visibility);
              
              const practiceOptionMatch =
                filters.practiceOption.length === 0 ||
                filters.practiceOption.some((filter) => filter.value === dateInfo.practice_option);
              
              return dateMatch && priceMatch && visibilityMatch && practiceOptionMatch;
            });

            // If no dates match, exclude this course
            return matchingDates.length > 0;
          }

          return true;
        })
        .flatMap(course => {
          // Only include dates that match all date-level filters
          const filteredDates = course.dates.filter(dateInfo => {
            const dateMatch =
              filters.date.length === 0 ||
              filters.date.some((filter) => filter.value === dateInfo.date);
            
            const priceMatch =
              filters.price.length === 0 ||
              filters.price.some((filter) => {
                return parseFloat(filter.value) === parseFloat(dateInfo.price_with_vat);
              });
            
            const visibilityMatch =
              filters.visibility.length === 0 ||
              filters.visibility.some((filter) => filter.value === dateInfo.visibility);
            
            const practiceOptionMatch =
              filters.practiceOption.length === 0 ||
              filters.practiceOption.some((filter) => filter.value === dateInfo.practice_option);
            
            return dateMatch && priceMatch && visibilityMatch && practiceOptionMatch;
          });

          return filteredDates.map(dateInfo => ({
            course,
            dateInfo,
            key: `${course.title}-${dateInfo._id || Math.random()}`
          }));
        });
    } else {
      // When no filters are applied
      return coursesData
        .filter((course) => course.region === regionfilter)
        .flatMap(course => 
          course.dates
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .map(dateInfo => ({
              course,
              dateInfo,
              key: `${course.title}-${dateInfo._id || Math.random()}`
            }))
        );
    }
  }, [isEntry, coursesData, regionfilter, filters]);
  
  // State for tracking filtered rows
  const [displayRows, setDisplayRows] = useState([]);

  // Calculate and update rows when courses data changes or filters change
  useEffect(() => {
    if (coursesData && coursesData.length > 0) {
      console.log("Calculating rows with filters:", JSON.stringify(filters));
      const rows = getDisplayRows();
      rowsRef.current = rows;
      setDisplayRows([...rows]); // Update state to force re-render
      console.log("Rows updated:", rows.length);
    }
  }, [coursesData, getDisplayRows, filters, regionfilter]);

  // Debugging information
  useEffect(() => {
    console.log("isEntry:", isEntry);
    console.log("Current filters:", JSON.stringify(filters));
  }, [isEntry, filters]);

  // Helper function to get the row span for a course
  const getRowSpan = useCallback((course) => {
    // Count how many dates from this course appear in the filtered rows
    return rowsRef.current.filter(row => row.course.courseid === course.courseid).length || 1;
  }, []);

  // Function to regenerate all payment links using batch processing
  const handleRegeneratePaymentLinks = async () => {
    const token = localStorage.getItem("sassoontoken");
    if (!token) {
      showNotification("Please login first.", "error");
      return;
    }

    const result = await Swal.fire({
      title: 'Regenerate Payment Links?',
      text: 'This will regenerate payment links for ALL course dates in small batches to prevent timeouts.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#333',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, start regeneration!',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) {
      return;
    }

    setIsRegenerating(true);
    setRegenerationReport(null);
    setRegenerationProgress({
      currentBatch: 0,
      totalBatches: 0,
      processedDates: 0,
      totalDates: 0,
      percentage: 0
    });

    try {
      // First, get the total number of dates
      const infoResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/regeneration-info`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { totalDates, totalCourses } = infoResponse.data;
      const batchSize = 5; // Process 5 dates at a time to prevent timeouts
      const totalBatches = Math.ceil(totalDates / batchSize);

      setRegenerationProgress(prev => ({
        ...prev,
        totalDates,
        totalBatches
      }));

      showNotification(`Starting regeneration of ${totalDates} dates across ${totalCourses} courses in ${totalBatches} batches...`, "info");

      // Accumulate results from all batches
      const finalReport = {
        totalCourses,
        totalDates,
        successful: [],
        failed: [],
        skipped: [],
        summary: {
          successCount: 0,
          failureCount: 0,
          skippedCount: 0
        }
      };

      // Process batches sequentially
      for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
        const offset = batchIndex * batchSize;
        
        setRegenerationProgress(prev => ({
          ...prev,
          currentBatch: batchIndex + 1,
          processedDates: Math.min(offset + batchSize, totalDates),
          percentage: Math.round(((batchIndex + 1) / totalBatches) * 100)
        }));

        try {
          const batchResponse = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/regenerate-payment-links-batch`,
            {
              batchSize,
              offset
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              timeout: 60000 // 60 second timeout per batch
            }
          );

          const batchReport = batchResponse.data.report;
          
          // Accumulate results
          finalReport.successful.push(...batchReport.successful);
          finalReport.failed.push(...batchReport.failed);
          finalReport.skipped.push(...batchReport.skipped);
          finalReport.summary.successCount += batchReport.summary.successCount;
          finalReport.summary.failureCount += batchReport.summary.failureCount;
          finalReport.summary.skippedCount += batchReport.summary.skippedCount;

          // Show progress notification
          showNotification(
            `Batch ${batchIndex + 1}/${totalBatches} completed: ${batchReport.summary.successCount} successful, ${batchReport.summary.failureCount} failed`,
            "info"
          );

          // Small delay between batches to prevent overwhelming the server
          if (batchIndex < totalBatches - 1) {
            await new Promise(resolve => setTimeout(resolve, 1000));
          }

        } catch (batchError) {
          console.error(`Error in batch ${batchIndex + 1}:`, batchError);
          finalReport.failed.push({
            courseId: 'BATCH_ERROR',
            courseTitle: `Batch ${batchIndex + 1}`,
            location: 'N/A',
            reason: `Batch processing failed: ${batchError.message}`
          });
          finalReport.summary.failureCount++;
          
          showNotification(
            `Batch ${batchIndex + 1} failed: ${batchError.message}`,
            "error"
          );
        }
      }

      setRegenerationReport(finalReport);
      setShowReportModal(true);
      
      const successRate = Math.round((finalReport.summary.successCount / (finalReport.summary.successCount + finalReport.summary.failureCount)) * 100);
      
      Swal.fire({
        title: 'Regeneration Complete!',
        html: `
          <div style="text-align: left;">
            <p><strong>✅ Successful:</strong> ${finalReport.summary.successCount}</p>
            <p><strong>❌ Failed:</strong> ${finalReport.summary.failureCount}</p>
            <p><strong>⏭️ Skipped:</strong> ${finalReport.summary.skippedCount}</p>
            <p><strong>📊 Success Rate:</strong> ${successRate}%</p>
          </div>
        `,
        icon: finalReport.summary.failureCount === 0 ? 'success' : 'warning',
        confirmButtonColor: '#333',
        confirmButtonText: 'View Detailed Report'
      }).then((result) => {
        if (result.isConfirmed) {
          setShowReportModal(true);
        }
      });

      // Refresh courses data to show updated payment links
      dispatch(fetchCourses());
      
    } catch (error) {
      console.error("Error regenerating payment links:", error);
      Swal.fire({
        title: 'Regeneration Failed',
        text: error.response?.data?.message || error.message,
        icon: 'error',
        confirmButtonColor: '#333'
      });
    } finally {
      setIsRegenerating(false);
      setRegenerationProgress({
        currentBatch: 0,
        totalBatches: 0,
        processedDates: 0,
        totalDates: 0,
        percentage: 0
      });
    }
  };

  // Function to close the report modal
  const closeReportModal = () => {
    setShowReportModal(false);
    setRegenerationReport(null);
  };

  // Function to regenerate a single failed date
  const handleRegenerateSingleDate = async (failedItem, index) => {
    const token = localStorage.getItem("sassoontoken");
    if (!token) {
      showNotification("Please login first.", "error");
      return;
    }

    // Extract date index from the failed item if available
    // For now, we'll need to find the date index by searching the course
    try {
      // First, let's get the course to find the date index
      const courseResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/courses/${failedItem.courseId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const course = courseResponse.data;
      let dateIndex = -1;

      // Find the date index by matching the date
      if (course.dates) {
        dateIndex = course.dates.findIndex(date => date.date === failedItem.date);
      }

      if (dateIndex === -1) {
        showNotification("Could not find the date in the course.", "error");
        return;
      }

      const result = await Swal.fire({
        title: 'Regenerate Payment Link?',
        html: `
          <div style="text-align: left;">
            <p><strong>Course:</strong> ${failedItem.courseTitle}</p>
            <p><strong>Location:</strong> ${failedItem.location}</p>
            <p><strong>Date:</strong> ${failedItem.date}</p>
            <p><strong>Previous Error:</strong> ${failedItem.reason}</p>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#333',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, regenerate!',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      // Show loading state
      Swal.fire({
        title: 'Regenerating Payment Link...',
        text: 'Please wait while we regenerate the payment link.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/regenerate-single-payment-link`,
        {
          courseId: failedItem.courseId,
          dateIndex: dateIndex
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Success - update the report
      const updatedReport = { ...regenerationReport };
      
      // Remove from failed list
      updatedReport.failed.splice(index, 1);
      updatedReport.summary.failureCount--;
      
      // Add to successful list
      updatedReport.successful.push(response.data.result);
      updatedReport.summary.successCount++;
      
      setRegenerationReport(updatedReport);

      Swal.fire({
        title: 'Success!',
        text: 'Payment link regenerated successfully.',
        icon: 'success',
        confirmButtonColor: '#333'
      });

      // Refresh courses data
      dispatch(fetchCourses());

    } catch (error) {
      console.error("Error regenerating single payment link:", error);
      Swal.fire({
        title: 'Regeneration Failed',
        text: error.response?.data?.message || error.message,
        icon: 'error',
        confirmButtonColor: '#333'
      });
    }
  };

  return (
    <div className="courses-places">
      <div className="back-button-container">
        <button className="back-button" onClick={() => navigate("/")}>
          <i className="bx bx-arrow-back"></i> Back to Dashboard
        </button>
      </div>

      <header className="courses-header__header">
        <h1 className="courses-header__header-title">COURSES & DATES</h1>
        <div className="courses-header__regions">
          <a href="#" className="region-link active">
            {region}
          </a>
        </div>
      </header>

      {/* Developer Settings with Password Protection */}
      {showDevSettings && isDevModeUnlocked && (
        <div className="developer-settings">
          <div className="dev-settings-header">
            <div className="dev-settings-indicator">
              <span>🔓 Developer Mode Active</span>
            </div>
            <button 
              className="lock-dev-mode-btn"
              onClick={() => {
                setIsDevModeUnlocked(false);
                setShowDevSettings(false);
                showNotification("Developer mode locked", "info");
              }}
              title="Lock Developer Mode"
            >
              <i className="bx bx-lock-alt"></i>
              Lock
            </button>
          </div>
          <div className="dev-settings-actions">
            <button 
              className={`regenerate-payment-links-btn ${isRegenerating ? 'loading' : ''}`}
              onClick={handleRegeneratePaymentLinks}
              disabled={isRegenerating}
            >
              {isRegenerating ? (
                <>
                  <i className="bx bx-loader-alt bx-spin"></i>
                  {regenerationProgress.totalBatches > 0 ? (
                    <span>
                      Batch {regenerationProgress.currentBatch}/{regenerationProgress.totalBatches} - 
                      {regenerationProgress.processedDates}/{regenerationProgress.totalDates} dates 
                      ({regenerationProgress.percentage}%)
                    </span>
                  ) : (
                    <span>Starting regeneration...</span>
                  )}
                </>
              ) : (
                <>
                  <i className="bx bx-refresh"></i>
                  Regenerate All Payment Links
                </>
              )}
            </button>
            {regenerationReport && (
              <button 
                className="view-report-btn"
                onClick={() => setShowReportModal(true)}
              >
                <i className="bx bx-file-blank"></i>
                View Last Report
              </button>
            )}
          </div>
          <div className="dev-settings-info">
            <small>
              <i className="bx bx-info-circle"></i>
              Press Alt+Shift+D to toggle developer settings
            </small>
          </div>
        </div>
      )}

      <button className="add-date-btn" onClick={() => openModal("newCourse")}>
        <span className="add-course-text">Add New Course</span>
        <i className="bx bxs-add-to-queue"></i>
      </button>
      <table className="courses-table">
        <thead>
          <tr>
            <th>
              <MultiSelect
                options={categoryOptions}
                selectedValues={filters.category}
                onChange={(selected) =>
                  handleFilterChange(selected, "category")
                }
                labelledBy="Category"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Category</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={titleOptions}
                selectedValues={filters.title}
                onChange={(selected) => handleFilterChange(selected, "title")}
                labelledBy="Title"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Title</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={durationOptions}
                selectedValues={filters.duration}
                onChange={(selected) =>
                  handleFilterChange(selected, "duration")
                }
                labelledBy="Duration"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Duration</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={locationOptions}
                selectedValues={filters.location}
                onChange={(selected) =>
                  handleFilterChange(selected, "location")
                }
                labelledBy="Location"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Location</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={dateOptions}
                selectedValues={filters.date}
                onChange={(selected) => handleFilterChange(selected, "date")}
                labelledBy="Date"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Date</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={priceOptions}
                selectedValues={filters.price}
                onChange={(selected) => handleFilterChange(selected, "price")}
                labelledBy="Price"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Price</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={visibilityOptions}
                selectedValues={filters.visibility}
                onChange={(selected) =>
                  handleFilterChange(selected, "visibility")
                }
                labelledBy="Visibility"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Visibility</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            <th>
              <MultiSelect
                options={practiceOptions}
                selectedValues={filters.practiceOption}
                onChange={(selected) =>
                  handleFilterChange(selected, "practiceOption")
                }
                labelledBy="Practice option"
                hasSelectAll={false}
                triggerElement={
                  <div className="booking-table__label">
                    <span>Practice Option</span>
                    <i className="bx bx-chevron-down"></i>
                  </div>
                }
              />
            </th>
            {showDevSettings && (
              <th>
                <div className="booking-table__label">
                  <span>Payment URL</span>
                </div>
              </th>
            )}
            <th># Places Available</th>
            <th># Booked Places</th>
            <th># Places Remaining</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="13" style={{ textAlign: "center", padding: "20px" }}>
                Loading courses data...
              </td>
            </tr>
          ) : displayRows.length === 0 ? (
            <tr>
              <td colSpan="13" style={{ textAlign: "center", padding: "20px" }}>
                No courses found. Try changing your filters or add a new course.
              </td>
            </tr>
          ) : (
            displayRows.map(({ course, dateInfo, key }, rowIndex) => {
              // Check if this is the first occurrence of this course in the filtered rows
              const isFirstOccurrence = rowIndex === 0 || 
                displayRows[rowIndex - 1].course.courseid !== course.courseid;
              
              // Calculate rowSpan only for the first occurrence of the course
              const rowSpan = isFirstOccurrence ? 
                displayRows.filter(row => row.course.courseid === course.courseid).length : 0;

              return (
                <React.Fragment key={key}>
                  <tr>
                    {isFirstOccurrence ? (
                      <>
                        <td rowSpan={rowSpan}>
                          {Array.isArray(course.category)
                            ? course.category.join(", ")
                            : course.category}
                        </td>
                        <td rowSpan={rowSpan}>
                          <div className="course-title-container">
                            <div className="course-title">{course.title}</div>
                            <div className="course-action-buttons">
                              <button
                                className="edit-link-btn"
                                onClick={() => {
                                  setEditCourse({ ...course });
                                  openModal("editCourse");
                                }}
                              >
                                Edit
                              </button>
                              <button
                                className="delete-link-btn"
                                onClick={async () => {
                                  const result = await Swal.fire({
                                    title: 'Delete Course?',
                                    text: `Are you sure you want to delete "${course.title}" permanently? This action cannot be undone.`,
                                    icon: 'error',
                                    showCancelButton: true,
                                    confirmButtonColor: '#d33',
                                    cancelButtonColor: '#333',
                                    confirmButtonText: 'Yes, delete it!',
                                    cancelButtonText: 'Cancel'
                                  });

                                  if (result.isConfirmed) {
                                    dispatch(deleteCourse(course.courseid));
                                    Swal.fire({
                                      title: 'Deleted!',
                                      text: `${course.title} has been deleted.`,
                                      icon: 'success',
                                      confirmButtonColor: '#333',
                                      timer: 2000,
                                      showConfirmButton: false
                                    });
                                  }
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </td>
                        <td rowSpan={rowSpan}>
                          {course.duration} {course.duration_unit}
                        </td>
                        <td rowSpan={rowSpan}>
                          {course.location}
                        </td>
                      </>
                    ) : null}
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "10px",
                          }}
                        >
                          <span>{dateInfo.date}</span>
                        </div>
                        {isFirstOccurrence && (
                          <div
                            style={{
                              marginTop: "10px",
                            }}
                          >
                            <button
                              className="edit-link-btn"
                              onClick={() =>
                                openModal("addDate", {
                                  ...dateInfo,
                                  courseId: course,
                                })
                              }
                            >
                              Add New Date
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      {formatPriceWithLabel(
                        dateInfo.price_with_vat,
                        dateInfo.price_without_vat,
                        dateInfo.currency || "",
                        dateInfo.visible_price,
                        dateInfo.deposit_amount,
                        regionfilter,
                        course
                      )}
                    </td>
                    <td>{dateInfo.visibility}</td>
                    <td>
                      {{
                        Notspecified: "Not specified",
                        Withmannequin: "With mannequin",
                        Withmodel: "With model",
                        "Withmannequin/model": "With mannequin/model",
                      }[dateInfo.practice_option] ||
                        dateInfo.practice_option}
                    </td>
                    {showDevSettings && (
                      <td>
                        {dateInfo.payment?.url ? (
                          <a
                            href={dateInfo.payment.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="payment-url-link"
                          >
                            Pay here
                          </a>
                        ) : (
                          <span className="no-payment-url">Not set</span>
                        )}
                      </td>
                    )}
                    {dateInfo.available_places === null ? (
                      <td></td>
                    ) : (
                      <td>{dateInfo.available_places}</td>
                    )}
                    {dateInfo.booked_places === null ||
                    dateInfo.booked_places === undefined ? (
                      <td></td>
                    ) : (
                      <td>{dateInfo.booked_places}</td>
                    )}
                    {dateInfo.booked_places === null ||
                    dateInfo.available_places === null ||
                    dateInfo.available_places === undefined ? (
                      <td>{dateInfo.available_places}</td>
                    ) : (
                      <td>
                        {dateInfo.available_places -
                          dateInfo.booked_places || "0"}
                      </td>
                    )}
                    {!dateInfo.date ? (
                      <td></td>
                    ) : (
                      <td>
                        <div className="date-action-buttons">
                          <button
                            className="edit-btn"
                            onClick={() => openModal("editDate", { ...dateInfo, courseId: dateInfo._id })}
                          >
                            Edit
                          </button>
                          <button
                            className="delete-btn"
                            onClick={async () => {
                              const result = await Swal.fire({
                                title: 'Delete Date?',
                                text: `Are you sure you want to delete the date "${dateInfo.date}" permanently? This action cannot be undone.`,
                                icon: 'error',
                                showCancelButton: true,
                                confirmButtonColor: '#d33',
                                cancelButtonColor: '#333',
                                confirmButtonText: 'Yes, delete it!',
                                cancelButtonText: 'Cancel'
                              });

                              if (result.isConfirmed) {
                                dispatch(deleteDate(dateInfo._id));
                                Swal.fire({
                                  title: 'Deleted!',
                                  text: `Date ${dateInfo.date} has been deleted.`,
                                  icon: 'success',
                                  confirmButtonColor: '#333',
                                  timer: 2000,
                                  showConfirmButton: false
                                });
                              }
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>

      {/* Modal to add or edit course */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Course Modal"
        className="modal-container"
      >
        <div className="modal-content">
          <h2>
            {modalType === "editDate"
              ? "Edit Date"
              : modalType === "editCourse"
              ? "Edit Course"
              : "Add New Date"}
          </h2>
          <button onClick={closeModal}>×</button>

          {modalType === "editDate" && selectedCourse && (
            <form
              className="edit-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const token = localStorage.getItem("sassoontoken");
                if (!token) {
                  showNotification("Please login first.", "error");
                  return;
                }
                const dataToSend = {
                  date: formData.date && /^\d{4}-\d{2}-\d{2}$/.test(formData.date) 
                    ? formatDate(formData.date)  // Format if it's in YYYY-MM-DD format
                    : formData.date,            // Otherwise, use as is
                  available_places: formData.availablePlaces,
                  price_with_vat: parseInt(formData.priceWithVat) || 0,
                  price_without_vat: parseInt(formData.priceExVat) || 0,
                  deposit_amount: formData.depositAmount ? parseInt(formData.depositAmount) : 0,
                  visibility: formData.visibility,
                  practice_option: formData.practiceOption,
                  currency: formData.currency,
                  visible_price: formData.visible_price,
                  actual_price: formData.actual_price,
                  payment: {
                    url: formData.payment?.url || "",
                    payment_link_id: formData.payment?.payment_link_id || "",
                    type: formData.payment?.type || "full",
                    percentage: formData.payment?.percentage || 0
                  }
                };

                try {
                  await axios.patch(
                    `${process.env.REACT_APP_API_URL}/api/dateupdate/${selectedCourse.courseId}`,
                    dataToSend,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  showNotification("Date updated successfully!", "success");
                  closeModal();
                  dispatch(fetchCourses());
                } catch (error) {
                  console.error("Error updating course:", error);
                  showNotification(
                    "Error updating course. Please try again.",
                    "error"
                  );
                }
              }}
            >
              <div className="form-grid">
                <div className="form-group">
                  <label>Date</label>
                  <input
                    type="date"
                    placeholder="date"
                    value={
                      formData.date && /^\d{4}-\d{2}-\d{2}$/.test(formData.date) 
                        ? formData.date // Keep as is if already in YYYY-MM-DD format
                        : formData.date && formData.date.includes(' ')
                        ? unformatDate(formData.date) // Convert from DD Month YYYY format
                        : ""
                    }
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        date: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Seats Available</label>
                  <input
                    type="number"
                    placeholder="Seats Available"
                    value={formData.availablePlaces}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        availablePlaces: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Currency</label>
                  <select
                    value={formData.currency}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        currency: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" disabled>
                      {" "}
                      Select a currency
                    </option>
                    <option value="GBP">GBP</option>
                    <option value="USD">USD</option>
                    <option value="CAD">CAD</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Deposit Amount</label>
                  <input
                    type="number"
                    placeholder="Deposit Amount"
                    value={formData.depositAmount}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        depositAmount: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Price with VAT</label>
                  <input
                    type="number"
                    placeholder="Price with VAT"
                    value={formData.priceWithVat}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        priceWithVat: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Price without VAT</label>
                  <input
                    type="number"
                    placeholder="Price without VAT"
                    value={formData.priceExVat}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        priceExVat: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Select Visible Price</label>
                  <select
                    value={formData.visible_price || "price_with_vat"}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        visible_price: e.target.value
                      });
                    }}
                    required
                  >
                    <option value="" disabled>Select Visible Price</option>
                    <option value="price_with_vat">Price with VAT</option>
                    <option value="price_without_vat">Price without VAT</option>
                    <option value="deposit_amount">Deposit Amount</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Select Actual Price (for payment)</label>
                  <select
                    value={formData.actual_price || "price_with_vat"}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        actual_price: e.target.value
                      });
                    }}
                    required
                  >
                    <option value="" disabled>Select Actual Price</option>
                    <option value="price_with_vat">Price with VAT</option>
                    <option value="price_without_vat">Price without VAT</option>
                    <option value="deposit_amount">Deposit Amount</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Visibility</label>
                  <select
                    value={formData.visibility}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        visibility: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="Shown">Shown</option>
                    <option value="Shownassoldout">Shown as sold out</option>
                    <option value="Shownaspublicholiday">
                      Shown as public holiday
                    </option>
                    <option value="Hidden">Hidden</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Practice Option</label>
                  <select
                    value={formData.practiceOption}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        practiceOption: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="Notspecified">Not specified</option>
                    <option value="Withmannequin">With mannequin</option>
                    <option value="Withmodel">With model</option>
                    <option value="Withmannequin/model">
                      With mannequin/model
                    </option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Payment Type</label>
                  <select
                    value={formData.payment?.type || "full"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        payment: {
                          ...(formData.payment || {}),
                          type: e.target.value
                        }
                      })
                    }
                  >
                    <option value="full">Full Payment</option>
                    <option value="deposit">Deposit</option>
                    <option value="custom">Custom</option>
                  </select>
                </div>

                {formData.payment?.type === "custom" && (
                  <div className="form-group">
                    <label>Payment Percentage</label>
                    <input
                      type="number"
                      placeholder="Payment Percentage"
                      value={formData.payment?.percentage || 0}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          payment: {
                            ...(formData.payment || {}),
                            percentage: parseInt(e.target.value) || 0
                          }
                        })
                      }
                    />
                  </div>
                )}
              </div>

              <div className="form-actions">
                <button type="submit">Update Date</button>
              </div>
            </form>
          )}

          {modalType === "addDate" && (
            <form
              className="edit-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const token = localStorage.getItem("sassoontoken");
                if (!token) {
                  showNotification("Please login first.", "error");
                  return;
                }
                let courseId =
                  selectedCourse.courseId?.courseid || selectedCourse._id;
                const dataToSend = {
                  course_id: selectedCourse._id,
                  date: formData.date && /^\d{4}-\d{2}-\d{2}$/.test(formData.date)
                    ? formatDate(formData.date)  // Format if it's in YYYY-MM-DD format
                    : formData.date,            // Otherwise, use as is
                  available_places: formData.availablePlaces,
                  price_with_vat: parseInt(formData.priceWithVat) || 0,
                  price_without_vat: parseInt(formData.priceExVat) || 0,
                  deposit_amount: formData.depositAmount ? parseInt(formData.depositAmount) : 0,
                  visibility: formData.visibility,
                  practice_option: formData.practiceOption,
                  currency: formData.currency,
                  visible_price: formData.visible_price,
                  actual_price: formData.actual_price,
                  payment: {
                    url: formData.payment?.url || "",
                    type: formData.payment?.type || "full",
                    percentage: formData.payment?.percentage || 0
                  }
                };

                try {
                  await axios.put(
                    `${process.env.REACT_APP_API_URL}/api/coursesupdate/${courseId}`,
                    dataToSend,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  showNotification("Date added successfully!", "success");

                  // Reset form data to initial state
                  setFormData(initialFormData);

                  closeModal();
                  dispatch(fetchCourses());
                } catch (error) {
                  console.error("Error updating course:", error);
                  showNotification(
                    "Failed to add date. Please try again.",
                    "error"
                  );
                }
              }}
            >
              <div className="form-grid">
                <div className="form-group">
                  <label>Date</label>
                  <input
                    type="date"
                    placeholder="Date"
                    value={formData.date}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        date: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Seats Available</label>
                  <input
                    type="number"
                    placeholder="Seats Available"
                    value={formData.availablePlaces}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        availablePlaces: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Currency</label>
                  <select
                    value={formData.currency}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        currency: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select a currency
                    </option>
                    <option value="GBP">GBP</option>
                    <option value="USD">USD</option>
                    <option value="CAD">CAD</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Deposit Amount</label>
                  <input
                    type="number"
                    placeholder="Deposit Amount"
                    value={formData.depositAmount}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        depositAmount: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Price with VAT</label>
                  <input
                    type="number"
                    placeholder="Price with VAT"
                    value={formData.priceWithVat}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        priceWithVat: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Price without VAT</label>
                  <input
                    type="number"
                    placeholder="Price without VAT"
                    value={formData.priceExVat}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        priceExVat: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Select Visible Price</label>
                  <select
                    value={formData.visible_price || "price_with_vat"}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        visible_price: e.target.value
                      });
                    }}
                    required
                  >
                    <option value="" disabled>Select Visible Price</option>
                    <option value="price_with_vat">Price with VAT</option>
                    <option value="price_without_vat">Price without VAT</option>
                    <option value="deposit_amount">Deposit Amount</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Select Actual Price (for payment)</label>
                  <select
                    value={formData.actual_price || "price_with_vat"}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        actual_price: e.target.value
                      });
                    }}
                    required
                  >
                    <option value="" disabled>Select Actual Price</option>
                    <option value="price_with_vat">Price with VAT</option>
                    <option value="price_without_vat">Price without VAT</option>
                    <option value="deposit_amount">Deposit Amount</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Visibility</label>
                  <select
                    value={formData.visibility}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        visibility: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="Shown">Shown</option>
                    <option value="Shownassoldout">Shown as sold out</option>
                    <option value="Shownaspublicholiday">
                      Shown as public holiday
                    </option>
                    <option value="Hidden">Hidden</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Practice Option</label>
                  <select
                    value={formData.practiceOption}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        practiceOption: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="Notspecified">Not specified</option>
                    <option value="Withmannequin">With mannequin</option>
                    <option value="Withmodel">With model</option>
                    <option value="Withmannequin/model">
                      With mannequin/model
                    </option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Payment Type</label>
                  <select
                    value={formData.payment?.type || "full"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        payment: {
                          ...(formData.payment || {}),
                          type: e.target.value
                        }
                      })
                    }
                  >
                    <option value="full">Full Payment</option>
                    <option value="deposit">Deposit</option>
                    <option value="custom">Custom</option>
                  </select>
                </div>

                {formData.payment?.type === "custom" && (
                  <div className="form-group">
                    <label>Payment Percentage</label>
                    <input
                      type="number"
                      placeholder="Payment Percentage"
                      value={formData.payment?.percentage || 0}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          payment: {
                            ...(formData.payment || {}),
                            percentage: parseInt(e.target.value) || 0
                          }
                        })
                      }
                    />
                  </div>
                )}
              </div>

              <div className="form-actions">
                <button type="submit">Add Date</button>
              </div>
            </form>
          )}

          {modalType === "editCourse" && (
            <form className="edit-form" onSubmit={handleEditCourseSubmit}>
              <div className="form-grid">
                {/* Title at top full-width */}
                <div className="form-group full-width">
                  <label htmlFor="title">Title</label>
                  <input
                    type="text"
                    name="title"
                    value={selectedCourseFormData.title}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        title: e.target.value,
                      }))
                    }
                    required
                  />
                </div>

                {/* Topic of Study and Location in two columns */}
                <div className="form-group no-checkbox-multiselect">
                  <label htmlFor="category">Topic of Study</label>
                  <div className="multi-select-container" onClick={(e) => e.stopPropagation()}>
                    <MultiSelect
                      options={categorySelectionOptions || []}
                      selectedValues={(
                        selectedCourseFormData.category || []
                      ).filter((cat) => cat != null)}
                      onChange={(selected) => {
                        handleMultiSelectChange(selected, "category");
                      }}
                      placeholder="Select categories..."
                      showSearch={true}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="location">Location</label>
                  <select
                    id="location"
                    name="location"
                    value={selectedCourseFormData.location}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        location: e.target.value,
                      }))
                    }
                    required
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    {username === "ukadmin" ? (
                      <>
                        <option value="Budapest">Budapest</option>
                        <option value="Global">Global</option>
                        <option value="London">London</option>
                        <option value="Manchester">Manchester</option>
                      </>
                    ) : (
                      <>
                        <option value="Boston">Boston</option>
                        <option value="Beverly Hills">Beverly Hills</option>
                        <option value="McLean">McLean</option>
                        <option value="New York">New York</option>
                        <option value="Scottsdale">Scottsdale</option>
                        <option value="Toronto">Toronto</option>
                      </>
                    )}
                  </select>
                </div>

                {/* Currency and Visible Price row */}
                <div className="form-group">
                  <label htmlFor="currency">Currency</label>
                  <select
                    id="currency"
                    name="currency"
                    value={selectedCourseFormData.currency}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        currency: e.target.value,
                      }))
                    }
                    required
                  >
                    {username === "ukadmin" ? (
                      <option value="GBP">GBP</option>
                    ) : (
                      <>
                        <option value="CAD">CAD</option>
                        <option value="USD">USD</option>
                      </>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="visible_price">Visible Price</label>
                  <input
                    type="number"
                    name="visible_price"
                    value={selectedCourseFormData.visible_price}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        visible_price: e.target.value,
                      }))
                    }
                    required
                  />
                </div>

                {/* Duration and Duration Unit */}
                <div className="form-group">
                  <label htmlFor="duration">Duration</label>
                  <input
                    type="number"
                    name="duration"
                    value={selectedCourseFormData.duration}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        duration: e.target.value,
                      }))
                    }
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="duration_unit">Duration Unit</label>
                  <select
                    id="duration_unit"
                    name="duration_unit"
                    value={selectedCourseFormData.duration_unit}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        duration_unit: e.target.value,
                      }))
                    }
                    required
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    <option value="Consecutive Mondays">
                      Consecutive Mondays
                    </option>
                    <option value="Day">Day</option>
                    <option value="Days">Days</option>
                    <option value="Hours per session">Hours per session</option>
                    <option value="Minutes">Minutes</option>
                    <option value="Weeks">Weeks</option>
                  </select>
                </div>

                {/* Salesforce Course ID and Stripe Account at the end */}
                <div className="form-group">
                  <label htmlFor="courseid">Salesforce Course ID</label>
                  <input
                    type="text"
                    name="courseid"
                    value={selectedCourseFormData.courseid}
                    required
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        courseid: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="region">Stripe Account</label>
                  <select
                    id="region"
                    name="region"
                    value={selectedCourseFormData.region}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        region: e.target.value,
                      }))
                    }
                    required
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    <option value="uk">VS Salons (UK)</option>
                    <option value="us">Sassoon Academy NA (US)</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="visibility">Visibility</label>
                  <select
                    id="visibility"
                    name="visibility"
                    value={selectedCourseFormData.visibility}
                    onChange={(e) =>
                      setSelectedCourseFormData((prevData) => ({
                        ...prevData,
                        visibility: e.target.value,
                      }))
                    }
                    required
                  >
                    <option value="show">Show</option>
                    <option value="hide">Hide</option>
                  </select>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit">Update Course</button>
              </div>
            </form>
          )}
        </div>
      </Modal>

      {/* Report Modal for Payment Link Regeneration */}
      <Modal
        isOpen={showReportModal}
        onRequestClose={closeReportModal}
        contentLabel="Payment Link Regeneration Report"
        className="modal-container report-modal"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h2>Payment Link Regeneration Report</h2>
            <button onClick={closeReportModal} className="close-btn">×</button>
          </div>
          
          {regenerationReport && (
            <div className="report-content">
              {/* Summary Section */}
              <div className="report-summary">
                <h3>Summary</h3>
                <div className="summary-stats">
                  <div className="stat-item success">
                    <i className="bx bx-check-circle"></i>
                    <span className="stat-number">{regenerationReport.summary.successCount}</span>
                    <span className="stat-label">Successful</span>
                  </div>
                  <div className="stat-item failed">
                    <i className="bx bx-x-circle"></i>
                    <span className="stat-number">{regenerationReport.summary.failureCount}</span>
                    <span className="stat-label">Failed</span>
                  </div>
                  <div className="stat-item skipped">
                    <i className="bx bx-minus-circle"></i>
                    <span className="stat-number">{regenerationReport.summary.skippedCount}</span>
                    <span className="stat-label">Skipped</span>
                  </div>
                  <div className="stat-item total">
                    <i className="bx bx-list-ul"></i>
                    <span className="stat-number">{regenerationReport.totalDates}</span>
                    <span className="stat-label">Total Dates</span>
                  </div>
                </div>
              </div>

              {/* Detailed Results */}
              <div className="report-details">
                {/* Successful Updates */}
                {regenerationReport.successful.length > 0 && (
                  <div className="report-section">
                    <h4 className="section-title success">
                      <i className="bx bx-check-circle"></i>
                      Successful Updates ({regenerationReport.successful.length})
                    </h4>
                    <div className="report-list">
                      {regenerationReport.successful.map((item, index) => (
                        <div key={index} className="report-item success">
                          <div className="item-info">
                            <strong>{item.courseTitle}</strong> - {item.location}
                            <br />
                            <span className="item-date">Date: {item.date}</span>
                            <span className="item-type">Payment Type: {item.paymentType}</span>
                          </div>
                          <div className="item-url">
                            <a href={item.paymentUrl} target="_blank" rel="noopener noreferrer">
                              View Payment Link
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Failed Updates */}
                {regenerationReport.failed.length > 0 && (
                  <div className="report-section">
                    <h4 className="section-title failed">
                      <i className="bx bx-x-circle"></i>
                      Failed Updates ({regenerationReport.failed.length})
                    </h4>
                    <div className="report-list">
                      {regenerationReport.failed.map((item, index) => (
                        <div key={index} className="report-item failed">
                          <div className="item-info">
                            <strong>{item.courseTitle}</strong> - {item.location}
                            <br />
                            <span className="item-date">Date: {item.date || 'N/A'}</span>
                            <span className="item-reason">Reason: {item.reason}</span>
                          </div>
                          {item.date && !item.reason.includes('Database update failed') && !item.reason.includes('Batch processing failed') && (
                            <div className="item-actions">
                              <button
                                className="retry-btn"
                                onClick={() => handleRegenerateSingleDate(item, index)}
                                title="Retry generating payment link for this date"
                              >
                                <i className="bx bx-refresh"></i>
                                Retry
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Skipped Updates */}
                {regenerationReport.skipped.length > 0 && (
                  <div className="report-section">
                    <h4 className="section-title skipped">
                      <i className="bx bx-minus-circle"></i>
                      Skipped Updates ({regenerationReport.skipped.length})
                    </h4>
                    <div className="report-list">
                      {regenerationReport.skipped.map((item, index) => (
                        <div key={index} className="report-item skipped">
                          <div className="item-info">
                            <strong>{item.courseTitle}</strong> - {item.location}
                            <br />
                            <span className="item-reason">Reason: {item.reason}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="report-actions">
                <button 
                  className="close-report-btn"
                  onClick={closeReportModal}
                >
                  Close Report
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default CoursesPlaces;
